module.exports = __webpack_public_path__ + "static/media/slide5.104595e8.png";